import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HeaderBlue = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleMouseEnter = (dropdownName) => {
        setOpenDropdown(dropdownName);
    };

    const handleMouseLeave = () => {
        setOpenDropdown(null);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    const dropdownItems = {
        CARRIERS: [
            { title: "Registration Process", path: "/carrier-registration" },
            { title: "Carrier Benefits", path: "/carrier-benefits" }
        ],
        DRIVERS: [
            { title: "Registration Process", path: "/driver-registration" },
            { title: "Driver Benefits", path: "/driver-benefits" }
        ],
        COMPANY: [
            { title: "About Us", path: "/about-us" },
            { title: "Truckers Forum", path: "/truckers-forum" },
            { title: "News & Blogs", path: "/news" },
            { title: "Contact Us", path: "/contact-us" }
        ],
        LOGIN: [
            { title: "Carrier", path: "/carrier-login" },
            { title: "Driver", path: "/driver-login" }
        ],
        SIGNUP: [
            { title: "Carrier", path: "/carrier-registration" },
            { title: "Driver", path: "/driver-registration" },
        ]
    };

    return (
        <header className="w-full absolute z-50">
            <div className="bg-gradient-to-b from-black/80 to-white/0 flex justify-between items-center px-4 py-4 md:px-20">
                <div className="text-white text-xl md:text-2xl font-bold">
                    <Link to="/">
                        <img
                            src="https://fleetycdl.com/assets/FleetyBlue.png"
                            alt="Fleety Logo"
                            className="h-20"
                        />
                    </Link>
                </div>

                {/* Hamburger Menu for Mobile */}
                <button
                    className="text-white text-2xl md:hidden focus:outline-none"
                    onClick={toggleMobileMenu}
                >
                    <i className="fas fa-bars"></i>
                </button>

                {/* Desktop Navigation */}
                <nav className="hidden md:block">
                    <ul className="flex flex-wrap items-center space-x-1 md:space-x-4">
                        <li
                            className="relative"
                            onMouseEnter={() => handleMouseEnter('COMPANY')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className="text-white px-3 py-2 text-sm md:text-base hover:text-gray-200 cursor-pointer">
                                COMPANY ▼
                            </div>
                            {openDropdown === 'COMPANY' && (
                                <div className="absolute bg-black min-w-48 py-2 rounded shadow-lg z-50">
                                    {dropdownItems.COMPANY.map((item, index) => (
                                        <Link
                                            key={index}
                                            to={item.path}
                                            className="block px-4 py-2 text-white hover:bg-gray-700 hover:text-white text-sm"
                                            onClick={handleMouseLeave}
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li
                            className="relative"
                            onMouseEnter={() => handleMouseEnter('CARRIERS')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className="text-white px-3 py-2 text-sm md:text-base hover:text-gray-200 hover:bg-gray-300 cursor-pointer">
                                CARRIERS ▼
                            </div>
                            {openDropdown === 'CARRIERS' && (
                                <div className="absolute bg-black min-w-48 py-2 rounded shadow-lg z-50">
                                    {dropdownItems.CARRIERS.map((item, index) => (
                                        <Link
                                            key={index}
                                            to={item.path}
                                            className="block px-4 py-2 text-white hover:bg-gray-700 hover:text-white text-sm"
                                            onClick={handleMouseLeave}
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li
                            className="relative"
                            onMouseEnter={() => handleMouseEnter('DRIVERS')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className="text-white px-3 py-2 text-sm md:text-base hover:text-gray-200 cursor-pointer">
                                DRIVERS ▼
                            </div>
                            {openDropdown === 'DRIVERS' && (
                                <div className="absolute bg-black min-w-48 py-2 rounded shadow-lg z-50">
                                    {dropdownItems.DRIVERS.map((item, index) => (
                                        <Link
                                            key={index}
                                            to={item.path}
                                            className="block px-4 py-2 text-white hover:bg-gray-700 hover:text-white text-sm"
                                            onClick={handleMouseLeave}
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li>
                            <Link
                                to="/pricing"
                                className="text-white px-3 py-2 text-sm md:text-base hover:text-gray-200"
                            >
                                PRICING
                            </Link>
                        </li>

                        <li
                            className="relative"
                            onMouseEnter={() => handleMouseEnter('LOGIN')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className="text-white px-3 py-2 text-sm md:text-base hover:text-gray-200 hover:bg-gray-300 cursor-pointer">
                                LOGIN ▼
                            </div>
                            {openDropdown === 'LOGIN' && (
                                <div className="absolute bg-black min-w-48 py-2 rounded shadow-lg z-50">
                                    {dropdownItems.LOGIN.map((item, index) => (
                                        <Link
                                            key={index}
                                            to={item.path}
                                            className="block px-4 py-2 text-white hover:bg-gray-700 hover:text-white text-sm"
                                            onClick={handleMouseLeave}
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li
                            className="relative"
                            onMouseEnter={() => handleMouseEnter('SIGNUP')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div className="signup text-white px-3 py-2 text-sm md:text-base hover:text-gray-200 cursor-pointer">
                                SIGN UP HERE ▼
                            </div>
                            {openDropdown === 'SIGNUP' && (
                                <div className="absolute bg-black min-w-48 py-2 rounded shadow-lg z-50">
                                    {dropdownItems.SIGNUP.map((item, index) => (
                                        <Link
                                            key={index}
                                            to={item.path}
                                            className="block px-4 py-2 text-white hover:bg-gray-700 hover:text-white text-sm"
                                            onClick={handleMouseLeave}
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </li>
                        <li>
                            <Link
                                to="/book-demo"
                                className="px-3 py-2 text-sm md:text-base rounded-full bg-white text-[#3c9bf9] font-semibold hover:bg-[#3c9bf9] hover:text-white transition"
                            >
                                BOOK DEMO
                            </Link>

                        </li>
                    </ul>
                </nav>

                {/* Mobile Sidebar Menu */}
                <div
                    className={`fixed top-0 right-0 h-full w-64 bg-black text-white transform transition-transform duration-300 ease-in-out z-50 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
                        }`}
                >
                    <div className="p-6 flex justify-between items-center border-b border-gray-700">
                        <span className="text-xl font-bold">Menu</span>
                        <button onClick={closeMobileMenu} className="text-2xl">
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    <ul className="flex flex-col space-y-4 p-6">
                        <li>
                            <button
                                className="w-full text-left text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={() => {
                                    setOpenDropdown(openDropdown === 'CARRIERS' ? null : 'CARRIERS');
                                }}
                            >
                                CARRIERS ▼
                            </button>
                            {openDropdown === 'CARRIERS' && (
                                <ul className="ml-4 space-y-2">
                                    {dropdownItems.CARRIERS.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className="block px-4 py-2 text-white hover:bg-gray-700 text-sm"
                                                onClick={closeMobileMenu}
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>

                        <li>
                            <button
                                className="w-full text-left text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={() => {
                                    setOpenDropdown(openDropdown === 'DRIVERS' ? null : 'DRIVERS');
                                }}
                            >
                                DRIVERS ▼
                            </button>
                            {openDropdown === 'DRIVERS' && (
                                <ul className="ml-4 space-y-2">
                                    {dropdownItems.DRIVERS.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className="block px-4 py-2 text-white hover:bg-gray-700 text-sm"
                                                onClick={closeMobileMenu}
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>

                        <li>
                            <Link
                                to="/pricing"
                                className="block text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={closeMobileMenu}
                            >
                                PRICING
                            </Link>
                        </li>

                        <li>
                            <button
                                className="w-full text-left text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={() => {
                                    setOpenDropdown(openDropdown === 'COMPANY' ? null : 'COMPANY');
                                }}
                            >
                                COMPANY ▼
                            </button>
                            {openDropdown === 'COMPANY' && (
                                <ul className="ml-4 space-y-2">
                                    {dropdownItems.COMPANY.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className="block px-4 py-2 text-white hover:bg-gray-700 text-sm"
                                                onClick={closeMobileMenu}
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>

                        <li>
                            <button
                                className="w-full text-left text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={() => {
                                    setOpenDropdown(openDropdown === 'LOGIN' ? null : 'LOGIN');
                                }}
                            >
                                LOGIN ▼
                            </button>
                            {openDropdown === 'LOGIN' && (
                                <ul className="ml-4 space-y-2">
                                    {dropdownItems.LOGIN.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className="block px-4 py-2 text-white hover:bg-gray-700 text-sm"
                                                onClick={closeMobileMenu}
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>

                        <li>
                            <button
                                className="w-full text-left text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={() => {
                                    setOpenDropdown(openDropdown === 'SIGNUP' ? null : 'SIGNUP');
                                }}
                            >
                                SIGN UP HERE ▼
                            </button>
                            {openDropdown === 'SIGNUP' && (
                                <ul className="ml-4 space-y-2">
                                    {dropdownItems.SIGNUP.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className="block px-4 py-2 text-white hover:bg-gray-700 text-sm"
                                                onClick={closeMobileMenu}
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                        <li>
                            <Link
                                to="/book-demo"
                                className="block text-white px-3 py-2 text-sm hover:bg-gray-700"
                                onClick={closeMobileMenu}
                            >
                                BOOK DEMO
                            </Link>
                        </li>
                    </ul>
                </div>

                {/* Overlay for Mobile Menu */}
                {isMobileMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={closeMobileMenu}
                    ></div>
                )}
            </div>
        </header>
    );
};

export default HeaderBlue;